import { LAB_CATEGORY_ORDER } from './labMakeupSchema';
import { CUSTOM_CATEGORY_OPTIONS } from './makeupCustomOptions';

function normHexId(id) {
  const s = String(id || '').trim();
  if (!/^#[0-9A-Fa-f]{6}$/.test(s)) return s;
  return s.toUpperCase();
}

export function optionIdForLayer(category, layer) {
  const options = CUSTOM_CATEGORY_OPTIONS[category];
  if (!options?.length) return '';
  if (!layer || layer.disabled) return 'none';
  if (category === 'foundation' && layer.autoSkin) return 'auto-skin';
  if (category === 'concealer' && (layer.autoSkinConcealer || layer.autoSkin)) return 'auto-concealer';
  if (layer.autoBlush) return 'auto-blush';
  if (layer.autoLip) return 'auto-lip';
  if (layer.autoEyeshadow) return 'auto-eyeshadow';
  if (layer.template && category === 'eyeliner') {
    const hit = options.find((o) => o.layer?.template === layer.template);
    return hit?.id || layer.template;
  }
  if (layer.template && category === 'eyelash') {
    const hit = options.find((o) => o.layer?.template === layer.template);
    return hit?.id || layer.template;
  }
  if (layer.color) {
    const hx = normHexId(layer.color);
    const hit = options.find((o) => normHexId(o.id) === hx);
    return hit?.id || hx;
  }
  if (String(layer.colorName || '').toLowerCase().includes('match guest')) return 'match';
  return '';
}

export function categorySelectOptions(category, layer) {
  const base = CUSTOM_CATEGORY_OPTIONS[category] || [];
  if (!layer || layer.disabled) return base;
  if (layer.template && (category === 'eyeliner' || category === 'eyelash')) {
    const tid = layer.template;
    if (!base.some((o) => o.layer?.template === tid)) {
      return [
        ...base,
        { id: tid, label: layer.styleName || tid, layer },
      ];
    }
    return base;
  }
  if (!layer.color) return base;
  const id = normHexId(layer.color);
  if (base.some((o) => normHexId(o.id) === id)) return base;
  const label = layer.colorName ? `${layer.colorName}` : id;
  return [...base, { id, label, layer }];
}

export function customLabOptionSignature(lab) {
  if (!lab) return '';
  return LAB_CATEGORY_ORDER.map((cat) => `${cat}:${optionIdForLayer(cat, lab[cat]) || 'none'}`).join('|');
}

export function downloadDataUrl(dataUrl, filename) {
  if (!dataUrl) return;
  const a = document.createElement('a');
  a.href = dataUrl;
  a.download = filename;
  a.click();
}

export function exportFluxLabConfig(presetId, customLab) {
  return JSON.stringify({ version: 1, presetId, customLab }, null, 2);
}

export function parseFluxLabConfigImport(text) {
  const data = JSON.parse(text);
  if (!data || typeof data !== 'object') throw new Error('Invalid config file');
  if (!data.customLab || typeof data.customLab !== 'object') throw new Error('Missing customLab');
  return { presetId: data.presetId || null, customLab: data.customLab };
}
